import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=261adf18&"
import script from "./Socios.vue?vue&type=script&lang=ts&"
export * from "./Socios.vue?vue&type=script&lang=ts&"
import style0 from "./Socios.vue?vue&type=style&index=0&id=261adf18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports